import React, { createContext, useContext, useState, useEffect } from "react";

interface RoleContextProps {
  role: string;
  setRole: (role: string) => void;
}

const RoleContext = createContext<RoleContextProps | undefined>(undefined);

export const RoleProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  // Load role from localStorage if available
  const [role, setRole] = useState<string>(
    localStorage.getItem("userRole") || ""
  );

  // Save role to localStorage when it changes
  useEffect(() => {
    if (role) {
      localStorage.setItem("userRole", role);
    }
  }, [role]);

  return (
    <RoleContext.Provider value={{ role, setRole }}>
      {children}
    </RoleContext.Provider>
  );
};

export const useRole = (): RoleContextProps => {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error("useRole must be used within a RoleProvider");
  }
  return context;
};
